import React, { useEffect, useState } from 'react';
import { Prompt } from 'react-router-dom';
import Phone from '../Phone/Phone';
import { ReactComponent as Arrow } from './chevron-right-solid.svg';
import { useSelector } from 'react-redux';
import { updateSettings } from '../../helper/updateSettings';

function validURL(str) {
	let pattern = new RegExp(
		'^(https?:\\/\\/)?' + // protocol
		'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
		'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
		'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
		'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
		'(\\#[-a-z\\d_]*)?$',
		'i',
	); // fragment locator
	return !!pattern.test(str);
}

const Welcome = () => {
	const { merchantId, merchantOptions, currentMerchant } = useSelector(
		state => ({
			merchantId: state.auth.user.merchantId,
			merchantOptions: state.merchants.merchants[0].options,
			currentMerchant: state.merchants.merchants[0],
		}),
	);

	const [selected, setSelected] = useState('section1');
	const [settings, setSettings] = useState(merchantOptions);
	const [isBlocking, setIsBlocking] = useState(false);
	const [alert, setAlert] = useState({
		display: false,
		message: '',
		type: '',
	});

	useEffect(() => {
		setSettings(merchantOptions);
	}, [merchantOptions]);

	const hasError = () => {
		let errors = [];
		if (settings.story && !validURL(settings.story)) {
			errors.push('Invalid Url');
		}
		if (errors.length) {
			return errors;
		} else {
			return false;
		}
	};

	const saveSettings = async () => {
		try {
			setAlert({ display: false });
			const errors = hasError();
			if (errors && errors?.length) {
				setAlert({ display: true, message: errors.join(','), type: 'danger' });
			} else {
				currentMerchant.options = { ...currentMerchant.options, ...settings }
				await updateSettings(currentMerchant, merchantId);
				setAlert({ display: true, message: 'Data saved successfully', type: 'primary' });
				setIsBlocking(false);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleChange = e => {
		if (e.target.type === 'checkbox') {
			setSettings({ ...settings, [e.target.name]: !settings[e.target.name] });
		} else {
			if (e.target.name === 'story') {
				setSettings({
					...settings,
					[e.target.name]: e.target.value.replace(/^(https:\/\/)/, ''),
				});
			} else {
				setSettings({ ...settings, popup: { Text: e.target.value } });
			}
		}
		setIsBlocking(true);
	};

	return (
		<>
			<div className='page-wrapper'>
				<Prompt
					when={isBlocking}
					// message={location => `Are you sure you want to go to ${location.pathname}`}
					message={location => `Save your modification?`}
				/>
				<div className='col-xxl-5'>
					<div className='card-visibility'>
						<div className='card-vi-header'>
							<span className='fw-bold text-dark'>Welcome</span>
						</div>
						<div className='card-body-visibility'>
							<div className='bah-accordion'>
								<div className='bah-accordion__element bah-border'>
									{alert.display && (
										<div
											profile='alert'
											className={`mb-10 alert alert-custom alert-light-${alert.type} alert-dismissible`}
										>
											<div className='alert-text font-weight-bold'>{alert.message}</div>
										</div>
									)}
									<input
										id='section1'
										name='test-accordion'
										type='radio'
										className='bah-accordion__element__check'
										checked={selected === 'section1'}
										onChange={() => { }}
									/>
									<label
										htmlFor='section1'
										className='bah-accordion__element__header fw-bold label-vi'
										onClick={() =>
											setSelected(old => (old === 'section1' ? 'section2' : 'section1'))
										}
									>
										Your welcome message
										<Arrow className='arrow-icon' />
									</label>
									<div className='bah-accordion__element__content'>
										<div className='content-wrapper'>
											<label className='input-label'>Activate welcome popup</label>
											<span className='switch switch-icon'>
												<label className='switch-label'>
													<input
														type='checkbox'
														name='isEnabled'
														value='isEnabled'
														checked={settings.isEnabled}
														onClick={handleChange}
														onChange={() => { }}
													/>
													<span className='checkbox-input'></span>
												</label>
											</span>
										</div>
										<div className='content-wrapper'>
											<textarea
												className='textarea-content'
												id='exampleTextarea'
												value={settings.popup?.Text}
												onChange={handleChange}
											></textarea>
											<span className='name-remember'>
												Introduce shortly your visitors to your community (60-80 characters)
											</span>
										</div>
									</div>
								</div>
								<div className='bah-accordion__element'>
									<input
										id='section2'
										name='test-accordion'
										type='radio'
										className='bah-accordion__element__check'
										checked={selected === 'section2'}
										onChange={() => { }}
									/>
									<label
										htmlFor='section2'
										className='bah-accordion__element__header fw-bold label-vi'
										onClick={() =>
											setSelected(old => (old === 'section1' ? 'section2' : 'section1'))
										}
									>
										Onboarding video (Optional) <Arrow className='arrow-icon' />
									</label>
									<div className='bah-accordion__element__content'>
										<div className='content-wrapper'>
											<div className='container-input'>
												<label className='input-label'>Add link</label>
												<div className='input-group'>
													<div className='input-group-prepend'>
														<span className='input-group-text input-control-span'>https://</span>
													</div>
													<input
														type='url'
														className='form-control input-control'
														name='story'
														value={settings.story}
														onChange={handleChange}
													/>
												</div>
												<div className='bottom-body'>
													<span className='name-remember'>This video will appear</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className='my-4 save-btn-wrapper'>
						<button className='btn btn-dark' onClick={saveSettings}>
							publish
						</button>
					</div>
				</div>
				<Phone />
			</div>
		</>
	);
};

export default Welcome;
